<template>
  <div
    class="card-list is-attachment"
    :class="(selectedConsignee === consigneeIdx) && `active`"
    v-if="!isDrawerVisible"
    @click="onClick"
    >
    <div class="list-top">
      <div class="d-flex">
        <i class="icon-source">
          <svgicon name="icon-vehicle-md" width="14" height="14" />
        </i>
        <span class="title">
          {{consignee.address.name}}
          <small>{{getConsigneeDetails(consignee)}}</small>
        </span>
        <span v-if="consignee.is_not_delivered" class="badge badge-bottom">
          <svgicon name="icon-warning-circle" class="f-right" width="12" height="12" :original="true"/>
          <svgicon name="not-delivered" width="67" height="14" :original="true"/>
        </span>
      </div>
    </div>
    <div class="d-flex mt-10 ml-15" v-if="hasViewEditLrPermission">
        <AttachmentsMin
          :disableUpload="disableUpload || !(addAttachmentsPermission && $hasPermission(addAttachmentsPermission))"
          :attachments="lrAttachments"
          :maxAllowed="lrAttachmentsLimit"
          :multiple=true
          :useModalUpload="$hasFeature('transporter_consolidated_attachment_management')"
          :showRemoveDocuments="!!(addAttachmentsPermission && $hasPermission(addAttachmentsPermission))"
          @addAttachments="addAttachments"
          @removeAttachments="removeAttachments"
          @openPreviewSlider="openPreviewSlider"/>
    </div>
    <h5 v-if="!isVisible"
    v-for="(lorryReceipt, index) in lrDetailsByCategory" :key="lorryReceipt.title"
      :class="{'is-select': editLr[`${lorryReceipt.title}`] &&
        (selectedConsignee === consigneeIdx)}">
      <label v-if="hasViewEditLrPermission">{{lorryReceipt.title}}</label>
      <span v-if="(editLr[`${lorryReceipt.title}`] || editLr[`${lorryReceipt.title}`] === '')
        && (selectedConsignee === consigneeIdx) && hasViewEditLrPermission">
        <input :placeholder="$t('INDENT_ENTER_LR_NUMBER')"
          v-model="lorryReceipt.lr_number" :disabled="!(editLrPermission && $hasPermission(editLrPermission))" class="lr-text" />
        <span class="action-edit">
          <i class="text-grey-medium" v-if="editLrPermission && $hasPermission(editLrPermission)" @click="clearLr(lorryReceipt)">
            <svgicon name="icon-close" width="8" height="8" />
          </i>
          <i class="text-blue" v-if="editLrPermission && $hasPermission(editLrPermission)" @click="saveLr(lorryReceipt)">
            <svgicon name="icon-tick-sm" width="10" height="10" />
          </i>
        </span>
      </span>
      <span class="form-value" v-else-if="lorryReceipt.lr_number">
        <Ellipsis v-if="hasViewEditLrPermission" v-bind:text="lorryReceipt.lr_number" :length="25"/>
      </span>
      <span class="form-value" v-else-if="canEditLr && editLrPermission && $hasPermission(editLrPermission)"> {{$t('INDENT_ENTER_LR_NUMBER')}} </span>
      <span class="form-value" v-else>-</span>
      <div class="card-actions" v-if="!editLr[`${lorryReceipt.title}`]
        && editLr[`${lorryReceipt.title}`] !== ''">
        <Tooltip :open-delay="100" effect="dark" placement="bottom-end" v-if="canEditLr && editLrPermission && $hasPermission(editLrPermission)">
          <div slot="content">{{$t('INDENT_EDIT_LR')}}</div>
          <i @click.stop="setEditableLr(lorryReceipt,lorryReceipt.lr_number)">
            <svgicon name="icon-edit-md" width="14" height="14" />
          </i>
        </Tooltip>
        <Tooltip :open-delay="100" effect="dark" placement="bottom-end"
          v-if="hasGenerateLr && lorryReceipt.lr_number && hasViewEditLrPermission" >
          <div slot="content">{{$t('INDENT_VIEW_LR')}}</div>
          <i @click="redirectToLrView(index)">
            <svgicon name="icon-view" width="14" height="14" :original="true"/>
          </i>
        </Tooltip>
      </div>
    </h5>
    <div class="d-block" v-if="isFTLIndent && isMaterialLREnabled">
      <div class="align-item-center justify-content text-capitalize my-10 pb-20">
        <label class="text-xs text-blue-dark3 mr-10 text-bold pl-10">
        Material Invoice - LR Number
        </label>
        <SwitchBtn
        v-model="isVisible"
        :disabled="sourceDestLRCheck"
        size="small"
        class="default-switch mr-10 f-right">
        </SwitchBtn>
        <div v-if="isVisible" class="mt-10">
            <Form class="form-default action-field action-field-form no-hover no-bg">
                <FormItem
                v-for="(invoiceDetails, index) in materialInvoiceLRList"
                :key="index"
                :label= "invoiceDetails.invoiceNo"
                class="bg-transparent"
                :class="{ 'active': isIndexEditable(index), 'no-border': !isIndexEditable(index) }"
                >
                <template v-if="isIndexEditable(index)">
                    <Input type="text"
                    placeholder="Enter Material Invoice LR"
                    v-model="enteredMaterialInvoiceLR"
                    size="mini" />
                        <div class="item-action">
                            <i class="secondary" @click="closeEditView()">
                            <svgicon name="icon-close" width="9" height="9"/>
                            </i>
                            <i class="primary" @click="saveMaterialInvoiceLR(invoiceDetails)">
                            <svgicon name="icon-tick-sm" width="12" height="9"/>
                            </i>
                        </div>
                </template>
                <template v-else>
                        <span class="form-value full-width" v-if="invoiceDetails.lr_number">
                        <Ellipsis v-bind:text="invoiceDetails.lr_number" :length="25"/>
                        <Tooltip v-if="canEditMaterialLR" effect="dark" placement="bottom-end">
                      <div slot="content">{{$t('INDENT_EDIT_LR')}}</div>
                         <i @click="makeEditable(index)" class="f-right">
                       <svgicon name="icon-edit-md" width="14" height="14" class="f-right pointer"/>
                             </i>
                        </Tooltip>
                        </span>
                    <span class="form-value" v-else-if="canEditMaterialLR" @click="makeEditable(index)"> {{$t('INDENT_ENTER_MATERIAL_INVOICE_LR')}} </span>
                   <span class="form-value" v-else>-</span>

                </template>
                </FormItem>
            </Form>
        </div>
      </div>
    </div>
    <template v-if="canShowConsignmentNumber">
      <div>
        <h5 class="action-right"
          v-for="(lrDetail,index) in lrDetailsByCategory"
          :key="index"
          :class="{'is-select': false}"
        >
          <label>{{$t('INDENT_CONSIGNMENT_NUMBER')}}</label>
          <div>
            <div class="form-value">
              <span v-if="getConsignmentNumberForLr(lrDetail)">{{getConsignmentNumberForLr(lrDetail)}}</span>
              <span v-else>-</span>
            </div>
          </div>
        </h5>
      </div>
    </template>
    <template v-if="$hasFeature('pod_rejection_by_ai') && podAiDestStatus">
      <div
        v-if="podAiDestStatus === 'AI_REJECTED'"
        class="pod-ai-rejected-tag"
        @click.stop="openPreviewSlider"
      >
        <svgicon name="icon-warning-circle" width="14" height="14" :original="true" />
        <span>{{ $t('POD_AI_REJECTED_TAG') }}</span>
        <svgicon
          name="icon-re-indent"
          width="14"
          height="14"
          class="pod-ai-retrigger-icon"
          @click.stop="resubmitPodValidation"
        />
      </div>
      <div
        v-else-if="podAiDestStatus === 'AI_APPROVED'"
        class="pod-ai-approved-tag"
      >
        <svgicon name="icon-tick-circle" width="14" height="14" />
        <span>{{ $t('POD_AI_ACCEPTED_TAG') }}</span>
      </div>
    </template>
  </div>
</template>
<script>
/* eslint-disable import/no-extraneous-dependencies */
import { mapGetters } from 'vuex';
import { isEmpty } from 'lodash';
import { LorryReceiptGenerationCategory, movementType, sourceAndDestinationType, InvertedMovements } from 'pando-constants';
import AttachmentsMin from '@common/components/AttachmentsMin';
import LrNumberListOnConfigMixin from '@common/mixins/document/LrNumberListOnConfigMixin';

export default {
  props: {
    isDrawerVisible: {
      type: Boolean,
      default: false,
    },
    fixedColumns: {
      type: Array,
      default: () => [],
    },
    orderNo: {
      type: Number,
      default: null,
    },
    slidableColumns: {
      type: Array,
      default: () => [],
    },
    selectedConsignee: {
      type: Number,
      default: 0,
    },
    destinations: {
      type: Array,
      default: () => [],
    },
    consignee: {
      type: Object,
      default: () => {},
    },
    source: {
      type: Object,
      default: () => {},
    },
    lorryReceipts: {
      type: Array,
      default: () => null,
    },
    consigneeIdx: {
      type: Number,
      default: 0,
    },
    editLr: {
      type: Object,
      default: () => {},
    },
    orderDetails: {
      type: Object,
      default: () => {},
    },
    lrGenerateCategory: {
      type: Number,
      default: 1,
    },
    isMultiDropGateConfig: {
      type: Boolean,
      default: false,
    },
    isMaterialsLoading: {
      type: Boolean,
      default: false,
    },
    uniqueDivisionsList: {
      type: Array,
      default: () => null,
    },
    legalEntityDetails: {
      type: Array,
      default: () => [],
    },
    lrAttachmentsLimit: {
      type: Number,
      default: 5,
    },
    podAiDestStatus: {
      type: String,
      default: null,
    },
    materialDetails: {
      type: Array,
      default: () => [],
    },
    materialsMetaData: {
      type: Object,
      default: () => {},
    },
    consgtNumberDetailsForConsignee: {
      type: Array,
      default: () => [],
    },
    isMaterialLREnabled: {
      type: Boolean,
      default: false,
    },
    disableUpload: {
      type: Boolean,
      default: false,
    },
  },
  mixins: [LrNumberListOnConfigMixin],
  created() {
    this.isVisible = this.isMaterialLRToggleEnabled;
  },
  data() {
    return {
      consigneeMaterials: null,
      movementType,
      sourceAndDestinationType,
      isVisible: false,
      isEditable: false,
      editableInvoiceIndex: null,
      showInput: false,
      enteredMaterialInvoiceLR: null,
    };
  },
  computed: {
    ...mapGetters({
      currentClient: 'app/currentClient',
    }),
    editLrPermission() {
      const movementSuffix = InvertedMovements[this.orderDetails.movement];
      return movementSuffix ? `edit_transporter_elr_${movementSuffix}` : null;
    },
    addAttachmentsPermission() {
      const movementSuffix = InvertedMovements[this.orderDetails.movement];
      return movementSuffix ? `transporter_add_elr_attachments_${movementSuffix}` : null;
    },
    hasViewEditLrPermission() {
      if (this.$hasPermission('view_transporter_elr')) {
        return true;
      }
      if (this.editLrPermission && this.$hasPermission(this.editLrPermission)) {
        return true;
      }
      if (this.addAttachmentsPermission && this.$hasPermission(this.addAttachmentsPermission)) {
        return true;
      }
      return false;
    },
    getDestArray() {
      return Object.keys(this.materialsMetaData) || [];
    },
    hasMaterials() {
      return this.destinations.some((dest) => {
        if (dest.source_location_id) {
          return this.getDestArray.includes(dest.location_id);
        }
        return false;
      });
    },
    isMaterialLRToggleEnabled() {
      if (!this.lorryReceipts || !this.lorryReceipts.length) {
        return false;
      }
      const materialInvoiceLR = this.lorryReceipts.find(lrDetails =>
        lrDetails.destination_location_id === this.consignee.location_id &&
        lrDetails.material_invoice_no,
      );
      return !!materialInvoiceLR;
    },
    hasGenerateLr() {
      return this.hasMaterials && this.$hasFeature('generate_lr');
    },
    canShowConsignmentNumber() {
      return this.consgtNumberDetailsForConsignee.length && this.$hasPermission('view_consignment_number');
    },
    getDepotSourceMap() {
      return this.orderDetails.sources.reduce((acc, source) => {
        if (source.type === this.sourceAndDestinationType.DEPOT) {
          const sourceGateId = source.gate_id;
          if (source.address && source.address.gates && source.gate_id) {
            // eslint-disable-next-line no-underscore-dangle
            const gateDetails = source.address.gates.find(val => val._id === sourceGateId);
            acc[`${source.location_id}_${source.gate_id}`] = gateDetails;
          }
        }
        return acc;
      }, {});
    },
    canEditLr() {
      const generateLr = this.orderDetails && this.orderDetails.transporter
        && this.orderDetails.transporter.generate_lr;
      return !generateLr;
    },
    canEditMaterialLR() {
      let materialInvoiceLRUpdate = true;
      if ([23, 7].includes(this.orderDetails.status)) {
        materialInvoiceLRUpdate = false;
      }
      return materialInvoiceLRUpdate;
    },
    lr() {
      if (!this.lorryReceipts || !this.lorryReceipts.length) {
        return [
          {
            division: 'DEFAULT',
            lr_number: '',
          },
        ];
      }
      return this.lorryReceipts;
    },
    lrDetailsByCategory() {
      if (this.lorryReceipts && this.lorryReceipts.length) {
        const sourceDestLR = this.lorryReceipts.find(lrDetails =>
          lrDetails.destination_location_id === this.consignee.location_id &&
        lrDetails.material_invoice_no,
        );
        if (sourceDestLR) {
          return [];
        }
      }
      let depotDetails = [];
      const lrGenerateCategory = this.lrGenerateCategory;
      if (lrGenerateCategory === LorryReceiptGenerationCategory.GATE_WISE) {
        depotDetails = this.getDepotSourceMap;
      }
      return this.getLrNumberDetailsDisplay({
        orderDetails: this.orderDetails,
        destinationDetails: this.consignee,
        lorryReceipts: this.lorryReceipts,
        lrGenerateCategory,
        depotDetails,
        divisionList: this.uniqueDivisionsList,
        isMultiDropGateConfig: this.isMultiDropGateConfig,
      });
    },
    materialInvoiceLRList() {
      const result = this.getMaterialLRDisplayDetails({
        orderDetails: this.orderDetails,
        destinationDetails: this.consignee,
        lorryReceipts: this.lorryReceipts,
        isMultiDropGateConfig: this.isMultiDropGateConfig,
      });
      return result;
    },
    sourceDestLRCheck() {
      if (!this.lorryReceipts || !this.lorryReceipts.length) {
        return false;
      }
      const sourceDestLR = this.lorryReceipts.find(lrDetails =>
        lrDetails.destination_location_id === this.consignee.location_id &&
        !lrDetails.material_invoice_no,
      );
      return !!sourceDestLR;
    },
    lrAttachments() {
      const hasPermission = this.$hasPermission('view_transporter_elr');
      if (this.consignee.lr_details && (hasPermission || this.$hasFeature('transporter_consolidated_attachment_management'))) {
        return this.consignee.lr_details.map(attachment => ({
          name: attachment.name,
          url: attachment.attachment_url,
          id: attachment.id,
        }));
      }
      return [];
    },
    getConsignmentNumberForLr() {
      return (lrDetails) => {
        if (lrDetails.legal_entity) {
          // re factor
          if (this.consgtNumberDetailsForConsignee.some(consignmentDetails =>
            (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
              consignmentDetails.tracking_data[0].legal_entity : false))) {
            const consignment = this.consgtNumberDetailsForConsignee.find(consignmentDetails =>
              (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
                lrDetails.legal_entity.title === consignmentDetails.tracking_data[0].legal_entity :
                false));
            return consignment ? consignment.tracking_data[0].booking_id : false;
          }
        } else if (lrDetails.division_id) {
          if (this.consgtNumberDetailsForConsignee.some(consignmentDetails =>
            (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
              consignmentDetails.tracking_data[0].division : false))) {
            const consignment = this.consgtNumberDetailsForConsignee.find(consignmentDetails =>
              (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
                lrDetails.division_id === consignmentDetails.tracking_data[0].division :
                false));
            return consignment ? consignment.tracking_data[0].booking_id : false;
          }
        } else if (lrDetails.source_gate_id) {
          if (this.consgtNumberDetailsForConsignee.some(consignmentDetails =>
            (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
              consignmentDetails.tracking_data[0].source_gate_id : false))) {
            const consignment = this.consgtNumberDetailsForConsignee.find(consignmentDetails =>
              (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
                lrDetails.source_gate_id === consignmentDetails.tracking_data[0].source_gate_id :
                false));
            return consignment ? consignment.tracking_data[0].booking_id : false;
          }
        }

        if (this.isMultiDropGateConfig) {
          if (this.consgtNumberDetailsForConsignee.some(consignmentDetails =>
            (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
              consignmentDetails.tracking_data[0].consignee_id : false))) {
            const consignment = this.consgtNumberDetailsForConsignee.find(consignmentDetails =>
              (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
                lrDetails.consignee_id === consignmentDetails.tracking_data[0].consignee_id :
                false));
            return consignment ? consignment.tracking_data[0].booking_id : false;
          }
        }

        if (this.consgtNumberDetailsForConsignee.some(consignmentDetails =>
          (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
            consignmentDetails.tracking_data[0].location_id : false))) {
          const consignment = this.consgtNumberDetailsForConsignee.find(consignmentDetails =>
            (consignmentDetails.tracking_data && consignmentDetails.tracking_data.length ?
              lrDetails.location_id === consignmentDetails.tracking_data[0].location_id :
              false));
          return consignment ? consignment.tracking_data[0].booking_id : false;
        }

        return false;
      };
    },
    isFTLIndent() {
      return this.orderDetails.vehicle_type_data.vehicle_type === 'FTL';
    },
  },
  methods: {
    redirectToLrView(index) {
      this.$addGAEvent('Indent Management', 'Click', 'Documents:View Autogenerated LR');
      const selectedLrDetails = this.lrDetailsByCategory[index];
      let url = '';
      if (selectedLrDetails.division_id) {
        url = this.url(this.orderDetails.order_no,
          selectedLrDetails.division_id, this.destinations[0].location_id);
      } else if (selectedLrDetails.legal_entity) {
        url = this.url(this.orderDetails.order_no,
          this.orderDetails.lorry_receipt[0].division,
          this.destinations[0].location_id, selectedLrDetails.legal_entity.source_gate_id,
          selectedLrDetails.legal_entity.gate_id, selectedLrDetails.legal_entity.source_location_id,
          selectedLrDetails.legal_entity.title);
      } else if (selectedLrDetails.source_gate_id) {
        url = this.url(this.orderDetails.order_no,
          this.orderDetails.lorry_receipt[0].division,
          this.destinations[0].location_id, selectedLrDetails.source_gate_id);
      } else {
        url = this.url(this.orderDetails.order_no,
          this.orderDetails.lorry_receipt[0].division, this.destinations[0].location_id);
      }
      window.open(url, '_blank');
    },
    url(orderNo, division, consigneeId, gateId, destinationGateId, sourceLocationId, legalEntityTitle) {
      this.$store.dispatch('order/lorry_receipt', { orderNo, division, consigneeId, gateId });
      const hostname = window.location.host;
      const isDevelopment = hostname.startsWith('localhost') || hostname.startsWith('127.0.0.1');
      const baseURL = isDevelopment ? 'http://localhost:3002/api' : '/api';
      if (gateId) {
        return `${baseURL}/order/lorry_receipt/${btoa(`clientId=${this.currentClient.id}&orderNo=${orderNo}&division=${division}&consigneeId=${consigneeId}&sourceGateId=${gateId}&destinationGateId=${destinationGateId}&sourceLocationId=${sourceLocationId}&legalEntityTitle=${legalEntityTitle}`)}`;
      }
      if (destinationGateId) {
        return `${baseURL}/order/lorry_receipt/${btoa(`clientId=${this.currentClient.id}&orderNo=${orderNo}&division=${division}&consigneeId=${consigneeId}&sourceGateId=${gateId}&destinationGateId=${destinationGateId}&sourceLocationId=${sourceLocationId}&legalEntityTitle=${legalEntityTitle}`)}`;
      }
      return `${baseURL}/order/lorry_receipt/${btoa(`clientId=${this.currentClient.id}&orderNo=${orderNo}&division=${division}&consigneeId=${consigneeId}&sourceLocationId=${sourceLocationId}&legalEntityTitle=${legalEntityTitle}`)}`;
    },
    async getTransporterBooking() {
      this.$store.dispatch('order/trackingList', { id: this.orderDetails.order_no });
    },
    getConsigneeDetails(destination) {
      const consigneeDetails = destination.address.reference_id;
      const gateDetailsMap = {};
      let destinations = [];
      if (this.isMultiDropGateConfig) {
        destinations = [destination];
      } else {
        destinations = this.orderDetails.destinations
          .filter(ele => ele.location_id === destination.location_id);
      }
      const depotDetails = destination.address;
      destinations.forEach((doc) => {
        if (depotDetails && depotDetails.gates) {
          // eslint-disable-next-line no-underscore-dangle
          const value = depotDetails.gates.find(gate => gate._id === doc.gate_id);
          if (value) {
            gateDetailsMap[value.reference_id] = value.reference_id;
          }
        }
      });
      const gateDetails = gateDetailsMap && !isEmpty(gateDetailsMap) ?
        Object.keys(gateDetailsMap) :
        [];
      return gateDetails.length ? `${consigneeDetails} - ${gateDetails.join(', ')}` : consigneeDetails;
    },
    async onClick() {
      if (this.consigneeIdx !== this.selectedConsignee) {
        await this.$emit('selectConsignee', this.consigneeIdx);
      }
    },
    openPreviewSlider() {
      if (this.$hasFeature('pod_rejection_by_ai') && this.podAiDestStatus === 'AI_REJECTED') {
        this.$emit('update:currentSelectedConsigneeLr', this.lrDetailsByCategory);
        this.$emit('setCurrentAttachments', this.lrAttachments);
        this.$emit('update:showRemoveDocuments', !(this.addAttachmentsPermission && this.$hasPermission(this.addAttachmentsPermission)));
        this.$emit('update:disableUpload', this.disableUpload || !(this.addAttachmentsPermission && this.$hasPermission(this.addAttachmentsPermission)));
        this.$emit('update:allowDelete', this.addAttachmentsPermission && this.$hasPermission(this.addAttachmentsPermission));
        this.$emit('openPodAiSlider', this.consignee);
        this.$emit('update:isDrawerVisible', true);
        return;
      }
      if (this.$hasPermission('view_transporter_elr') || (this.addAttachmentsPermission && this.$hasPermission(this.addAttachmentsPermission))) {
        if (this.$hasFeature('transporter_consolidated_attachment_management')) {
          this.$emit('openPreviewSlider', this.consigneeIdx);
          return;
        }
        this.$emit('setCurrentAttachments', this.lrAttachments);
        this.$emit('update:currentSelectedConsigneeLr', this.lrDetailsByCategory);
        this.$emit('update:isDrawerVisible', true);
        this.$emit('update:showRemoveDocuments', !(this.addAttachmentsPermission && this.$hasPermission(this.addAttachmentsPermission)));
        this.$emit('update:disableUpload', this.disableUpload || !(this.addAttachmentsPermission && this.$hasPermission(this.addAttachmentsPermission)));
        this.$emit('update:allowDelete', this.addAttachmentsPermission && this.$hasPermission(this.addAttachmentsPermission));
      }
    },
    async resubmitPodValidation() {
      try {
        const destinationName = this.consignee.address && this.consignee.address.name;
        const hasConfirm = await this.$PromptConfirm(
          this.$t('POD_AI_RETRIGGER_CONFIRM_MSG', { destName: destinationName }),
          this.$t('POD_AI_RETRIGGER_TITLE'),
          {
            confirmButtonText: 'Retrigger',
            cancelButtonText: 'Cancel',
            customClass: 'pod-ai-retrigger-confirm',
          },
        );
        if (hasConfirm === 'confirm') {
          const orderNo = this.orderDetails.order_no;
          const destinationId = this.consignee.location_id;
          await this.$store.dispatch('podAiValidation/resubmit', { orderNo, destinationId });
          this.$successMessage({ message: this.$t('POD_AI_RETRIGGER_SUCCESS') });
        }
      } catch (err) {
        if (err !== 'cancel') {
          this.$errorMessage({ message: err?.data?.error || 'Failed to resubmit POD validation' });
        }
      }
    },
    async addAttachments(file) {
      if (this.addAttachmentsPermission && this.$hasPermission(this.addAttachmentsPermission)) {
        await this.$emit('addAttachments', file, this.consigneeIdx);
      }
    },
    async removeAttachments(file) {
      if (this.addAttachmentsPermission && this.$hasPermission(this.addAttachmentsPermission)) {
        await this.$emit('removeAttachments', file);
      }
    },
    async setEditableLr(lorryReceipt, prevLr) {
      if (this.selectedConsignee !== this.consigneeIdx) {
        await this.$emit('selectConsignee', this.consigneeIdx);
      }
      const editLr = this.editLr;
      editLr[`${lorryReceipt.title}`] = prevLr;
      this.$emit('updateEditLr', editLr);
    },
    clearLr(lorryReceipt) {
      const lrReceipt = lorryReceipt;
      lrReceipt.lr_number = this.editLr[`${lorryReceipt.title}`];
      const editLr = this.editLr;
      editLr[`${lorryReceipt.title}`] = null;
      this.$emit('updateEditLr', editLr);
    },
    closeEditView() {
      this.editableInvoiceIndex = null;
      this.enteredMaterialInvoiceLR = null;
    },
    async saveLr(lorryReceipt) {
      try {
        const data = [];
        const tempData = {
          destination_id: this.consignee.location_id,
          ...!isEmpty(this.consignee.gate_id) ? { gate_id: this.consignee.gate_id } : {},
          source_location_id: lorryReceipt.source_location_id || this.consignee.source_location_id,
          ...((lorryReceipt.source_gate_id || this.consignee.source_gate_id) ? { source_gate_id: lorryReceipt.source_gate_id || this.consignee.source_gate_id } : {}),
          lr_number: lorryReceipt.lr_number && lorryReceipt.lr_number.trim(),
        };
        if (this.lrGenerateCategory === LorryReceiptGenerationCategory.LEGAL_ENTITY_WISE) {
          tempData.legal_entity = lorryReceipt.legal_entity.title;
        } else if (this.lrGenerateCategory === LorryReceiptGenerationCategory.DIVISION_WISE) {
          tempData.division = lorryReceipt.title;
        } else if (this.lrGenerateCategory === LorryReceiptGenerationCategory.GATE_WISE) {
          tempData.source_gate_id = lorryReceipt.source_gate_id;
        }
        data.push(tempData);
        await this.$emit('saveLr', {
          data,
          division: lorryReceipt.title,
        });
        return 'done';
      } catch (error) {
        return error;
      }
    },
    async saveMaterialInvoiceLR(invoiceDetails) {
      try {
        const data = [
          {
            destination_id: this.consignee.location_id,
            source_location_id:
            this.consignee.source_location_id,
            ...!isEmpty(this.consignee.gate_id) ? { gate_id: this.consignee.gate_id } : {},
            material_invoice: invoiceDetails.invoiceNo,
            lr_number: this.enteredMaterialInvoiceLR && this.enteredMaterialInvoiceLR.trim(),
          }];
        await this.$emit('saveMaterialInvoiceLevelLR', {
          data,
        });
        this.closeEditView();
        return 'done';
      } catch (error) {
        return error;
      }
    },
    makeEditable(index) {
      this.editableInvoiceIndex = index;
      this.showInput = true;
      this.enteredMaterialInvoiceLR = this.materialInvoiceLRList
      && this.materialInvoiceLRList[index].lr_number;
    },
    isIndexEditable(index) {
      return this.editableInvoiceIndex === index;
    },
    toggleVisibility() {
      this.isVisible = !this.isVisible;
    },
  },
  components: {
    AttachmentsMin,
  },
};
</script>
<style lang="scss">
.lr-text {
  background-color: transparent;
  width: 190px;
  margin-right: 10px;
  border: none;
  &:focus {
    outline: none;
  }
}
.action-md {
  width: 50px !important;
  height: 50px !important;
}
.item-thumbnail {
  width: 30px;
  height: 30px;
  margin: 10px;
}
.pod-ai-rejected-tag {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #fdecea;
  color: #c0392b;
  font-size: 1.2rem;
  font-weight: 500;
  padding: 8px 10px;
  border-top: 1px solid #f5c6c2;
  border-radius: 0 0 2px 2px;

  .pod-ai-retrigger-icon {
    margin-left: auto;
    cursor: pointer;
    opacity: 0.7;
    fill: #c0392b;
    &:hover { opacity: 1; }
  }
}
.pod-ai-approved-tag {
  display: flex;
  align-items: center;
  gap: 6px;
  background-color: #eafaf1;
  color: #1e8449;
  font-size: 1.2rem;
  font-weight: 500;
  padding: 8px 10px;
  border-top: 1px solid #a9dfbf;
  border-radius: 0 0 2px 2px;
  svg { fill: #1e8449; }
}
</style>
